// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"90":"css/pages/cart","252":"css/app","253":"css/pages/product","343":"css/pages/profile","596":"css/pages/checkout","642":"css/pages/archive","760":"admin_assets/css/app"}[chunkId] + ".css";
};